module.exports = __webpack_public_path__ + "static/media/professional-owl.74227315.svg";